/* Returns a random int n between [0..[max */
export const randomInt: (max: number) => number = max => Math.floor(Math.random() * Math.floor(max))
/* Returns a generator that generates ints as randomInt with predefined max */
export const randomIntGen: (max: number) => () => number = max => () => randomInt(max)
